import { useReadonlyField } from 'components/common-form/contexts/readonly/FieldMetadataContext';
import { FormattedMessage } from 'components/shared/Intl';
import { IntlKey } from 'locales';
import { ScheduleDatesGridValueDefinition } from 'models/metadata/readonlyValue.definition';
import { FC, useMemo } from 'react';
import type { QuoteWorkspaceVersion } from 'state/userPreferences/userPreferences.model';
import { camelCaseToWords } from 'utils/string';

import type { ProductSummaryCellMetadata } from './ScheduleDate.model';
import { ProductSummaryScheduleDatesRows } from './ScheduleDatesRows';

type ProductSummaryScheduleDatesState = {
  node: ScheduleDatesGridValueDefinition;
  quoteWorkspaceVersion: QuoteWorkspaceVersion;
  mustForceAdvancedMode: boolean;
};

export const ProductSummaryScheduleDatesField: FC<ProductSummaryScheduleDatesState> = ({
  node,
  quoteWorkspaceVersion,
  mustForceAdvancedMode,
}) => {
  const { getMetadataWithData } = useReadonlyField();
  const scheduleDatesRows = getMetadataWithData(node);
  const columns = node.columns as ProductSummaryCellMetadata[];

  const filteredColumns = useMemo(
    () =>
      columns.filter(
        m =>
          !(
            (m.isForAdvancedMode === true && quoteWorkspaceVersion !== 'Advanced' && mustForceAdvancedMode === false) ||
            m.isHidden === true
          ),
      ),
    [columns, quoteWorkspaceVersion, mustForceAdvancedMode],
  );

  return (
    scheduleDatesRows && (
      <table className="table table-striped">
        <thead>
          <tr>
            {filteredColumns.map(column => {
              const key = column.translationKey ?? column.id;
              return (
                <th key={key}>
                  <FormattedMessage id={`form.${key}` as IntlKey} defaultMessage={camelCaseToWords(key)} />
                </th>
              );
            })}
          </tr>
        </thead>
        <ProductSummaryScheduleDatesRows scheduleDatesRows={scheduleDatesRows} metadata={filteredColumns} />
      </table>
    )
  );
};

ProductSummaryScheduleDatesField.displayName = 'ProductSummaryScheduleDatesField';
